export const adminAuth = () => {
    const isAdminAuth = sessionStorage?.getItem('adminAuth');

    if (isAdminAuth === 'true' || isAdminAuth === true) {
        return true;
    } else {
        return false;
    }
};
